import React from "react";
import { User } from "lucide-react";
import { AuthImg } from "@/components/AuthImg";

export const PersonAvatar = ({ person, size = 48 }) => {
  const initials = `${(person?.first_name || "")[0] || "?"}${(person?.last_name || "")[0] || ""}`.toUpperCase();
  const bgByGender = person?.gender === "female" ? "#D9822B" : person?.gender === "male" ? "#993D22" : "#6B4226";
  const sz = { width: size, height: size };

  const fallback = (
    <div
      style={{ ...sz, background: bgByGender }}
      className="rounded-full flex items-center justify-center text-[#FAF7F2] font-serif-heritage font-semibold select-none"
      aria-label={initials}
    >
      <span style={{ fontSize: size * 0.4 }}>{initials}</span>
    </div>
  );

  if (!person?.photo_path) return fallback;
  return (
    <div style={sz} className="rounded-full overflow-hidden border-2 border-[#E3D5CA]">
      <AuthImg
        path={person.photo_path}
        alt={initials}
        className="w-full h-full object-cover"
        fallback={fallback}
      />
    </div>
  );
};

export default PersonAvatar;
